import React from 'react';
import PropTypes from 'prop-types';

function CommonPaperVoca({ vocaList = [], config }) {
  // console.log('vocabList Common:', vocaList);
  return (
    <div style={{ border: '1px solid black' }}>
      {vocaList.map((voca, idx) => {
        return (
          <div
            key={`${voca.type}-${String(idx)}`}
            style={{
              display: 'grid',
              gridTemplateColumns: '4fr 0.1fr 4fr',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              // marginTop: `${config?.spacing * 8}px`,
              fontSize: `${config?.fontSize + 2}px`,
              fontFamily: "'Pretendard', Arial, sans-serif",
              width: '100%',
              gap: '5px',
              borderBottom:
                idx !== vocaList?.length - 1 ? '1px solid black' : 'none',
            }}
          >
            <div
              style={{
                fontFamily: "'Pretendard', Arial, sans-serif",
                padding: '5px',
                lineHeight: config.spacing + 0.5,
              }}
            >
              {voca?.eng}
            </div>
            <div
              style={{
                width: '1px',
                height: '100%',
                borderRight: '1px solid black',
              }}
            />
            <div
              style={{
                fontFamily: "'Pretendard', Arial, sans-serif",
                // borderLeft: '1px solid black',
                padding: '5px 5px 5px 0',
                lineHeight: config.spacing + 0.5,
              }}
            >
              {voca?.kor}
            </div>
          </div>
        );
      })}
    </div>
  );
}

CommonPaperVoca.propTypes = {
  vocaList: PropTypes.array,
  config: PropTypes.object,
};

export default CommonPaperVoca;
